// 🎨 Dark Theme Only - Beautiful Eye-Catching Colors
// User loved the dark theme, so we locked it in!

export const theme = {
  // Backgrounds - Deep and immersive
  background: '#0F0F0F',      // Deep black
  surface: '#1A1A1A',         // Dark surface
  
  // Text - Soft and easy on eyes
  text: '#F9FAFB',            // Soft white
  textSecondary: '#9CA3AF',   // Muted light gray
  
  // Borders - Visible but not harsh
  border: '#2D2D2D',          // Dark gray
  
  // Brand colors - Vibrant and eye-catching!
  primary: '#6366F1',         // Vibrant indigo
  primaryHover: '#818CF8',    // Lighter indigo
  secondary: '#EC4899',       // Hot pink
  accent: '#8B5CF6',          // Purple
  
  // Status - Clear and visible
  success: '#10B981',         // Emerald green
  error: '#EF4444',           // Red
  warning: '#F59E0B',         // Amber
  info: '#3B82F6',            // Blue
  
  // Gradients - Beautiful flows
  gradientFrom: '#6366F1',
  gradientVia: '#8B5CF6',
  gradientTo: '#EC4899',
};

// Helper to get theme colors (always returns dark theme now)
export const getTheme = () => theme;

// Gradient CSS helpers
export const getGradientBackground = () => {
  return `linear-gradient(135deg, #6366F1 0%, #8B5CF6 50%, #EC4899 100%)`;
};

export const getGradientFlow = () => {
  return `linear-gradient(270deg, #6366F1, #8B5CF6, #EC4899, #8B5CF6)`;
};
